import type { UploadResult } from "@uppy/core"
import { Uppy } from "@uppy/core"
import type { AbiItem } from "web3-utils"

import { useToast } from "common/hooks/useToast"
import { filterAbiMethodsForProposal } from "createProposal/helpers/abi"
import { jsonParse } from "common/helpers/serialization"

type Values = {
  uppy: Uppy
}

export const useUploadAbi = (
  setUploadedAbiMethods: (result: AbiItem[]) => void,
): Values => {
  const { toast } = useToast()

  const uppy = new Uppy({
    meta: { type: "abiFile" },
    restrictions: { maxNumberOfFiles: 1 },
    autoProceed: true,
  })

  uppy.on("complete", (result: UploadResult) => {
    const [file] = result.successful
    const { data, type } = file

    if (type !== "application/json") {
      toast({
        status: "error",
        title: "Incorrect format",
        description: "File should be a JSON",
      })

      return
    }

    const fileReader = new FileReader()

    fileReader.onload = function (event: ProgressEvent<FileReader>): void {
      const result = event.target?.result

      if (!result) return

      const parsedResult = jsonParse(result as string)

      const contractABI = parsedResult.abi ?? parsedResult

      const contractABISelected = Array.isArray(contractABI)
        ? contractABI
        : jsonParse(contractABI.result)

      const abiMethods = filterAbiMethodsForProposal(contractABISelected)

      setUploadedAbiMethods(abiMethods)
    }

    fileReader.readAsText(data)
  })

  return {
    uppy,
  }
}
